import { z } from 'zod';
export const FraudSeveritySchema = z.enum(['INFO', 'WARNING', 'CRITICAL']);
export const FraudCaseStatusSchema = z.enum(['OPEN', 'RESOLVED', 'DISMISSED']);
// One detective hit (what a report returns + what the upsert consumes).
export const FraudFindingSchema = z.object({
    detectionType: z.string(),
    dedupKey: z.string(),
    severity: FraudSeveritySchema,
    title: z.string(),
    detail: z.record(z.string(), z.unknown()).optional(),
    relatedBillIds: z.array(z.string()),
    relatedPaymentIds: z.array(z.string()),
    relatedJournalIds: z.array(z.string()),
});
// A persisted case row (dashboard feed). Dates are wire strings or Date.
export const FraudFlagSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    detectionType: z.string(),
    severity: FraudSeveritySchema,
    status: FraudCaseStatusSchema,
    dedupKey: z.string(),
    title: z.string(),
    detail: z.unknown().nullable(),
    relatedBillIds: z.array(z.string()),
    relatedPaymentIds: z.array(z.string()),
    relatedJournalIds: z.array(z.string()),
    flaggedAt: z.union([z.string(), z.date()]),
    lastSeenAt: z.union([z.string(), z.date()]),
    resolvedAt: z.union([z.string(), z.date()]).nullable(),
    resolvedBy: z.string().nullable(),
    comment: z.string().nullable(),
});
// The dashboard list filter (querystring).
export const FraudFlagQuerySchema = z.object({
    status: FraudCaseStatusSchema.optional(),
    type: z.string().optional(),
});
// resolve / dismiss bodies — a non-empty comment is required for the audit trail.
export const ResolveFraudFlagSchema = z.object({ comment: z.string().min(1) });
// The 7 detective report codes (the locked set).
export const FRAUD_DETECTION_TYPES = [
    'DUP_DISB',
    'NEAR_DUP',
    'SPLIT_SUM',
    'PAY_BEFORE_APPROVAL',
    'MANUAL_JV_AP_TRADE',
    'APPROVAL_BYPASSED',
    'CROSS_VENDOR_TAXID',
];
//# sourceMappingURL=fraud.js.map